<template>
  <div class="wrapper-full mw-mask" @click="hideSort">
    <div class="sort-containner" @click.stop>
      <div class="sort-asc-desc">
        <Radio
          v-for="(item, index) in ascDescs"
          :key="item.index"
          :index="index"
          :checked="item.checked"
          eventName="setAscDesc"
          @setAscDesc="setAscDesc"
          >{{ $t(`langcfg.${item.label}`) }}</Radio
        >
      </div>
      <div class="sort-items">
        <div
          style="width: 420px; padding-left: 80px"
          v-for="(item, index) in sortItems"
          :key="item.index"
        >
          <Radio
            :index="index"
            :checked="item.checked"
            eventName="setSortItem"
            @setSortItem="setSortItem"
            >{{ $t(`langcfg.${item.label}`) }}</Radio
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Radio from "../../common/components/Radio";
export default {
  name: "Sort",
  data() {
    return {
      ascDescs: [
        { key: "asc", checked: false, label: "txtAsc", value: 1 },
        { key: "desc", checked: true, label: "txtDesc", value: -1 }
      ],
      sortItems: [
        { key: "creationdate", checked: true, label: "txtCreationDate" },
        { key: "pid", checked: false, label: "txtPID" },
        { key: "birthday", checked: false, label: "txtDateOfBirth" }
      ],
      sort: {
        key: "",
        asc_dsc: ""
      }
    };
  },
  props: {
    sortSettings: {
      type: Object,
      default: () => {
        return {
          key: "creationdate",
          asc_desc: -1
        };
      }
    }
  },
  components: {
    Radio
  },
  created() {
    this.sort = this.sortSettings;
    for (let id in this.ascDescs) {
      this.ascDescs[id].checked = this.ascDescs[id].value === this.sortSettings.asc_desc;
    }
    for (let id in this.sortItems) {
      this.sortItems[id].checked = this.sortItems[id].key === this.sortSettings.key;
    }
  },
  methods: {
    setSortItem(index) {
      let cond = "creationdate";
      for (let id = 0; id < this.sortItems.length; id++) {
        if (id === index) {
          cond = this.sortItems[id].key;
          this.sortItems.splice(index, 1, {
            key: this.sortItems[id].key,
            label: this.sortItems[id].label,
            checked: true
          });
        } else {
          this.sortItems.splice(id, 1, {
            key: this.sortItems[id].key,
            label: this.sortItems[id].label,
            checked: false
          });
        }
      }
      this.sort.key = cond;
    },
    setAscDesc(index) {
      let ad = -1;
      for (let id = 0; id < this.ascDescs.length; id++) {
        if (id === index) {
          ad = this.ascDescs[id].value;
          this.ascDescs.splice(index, 1, {
            key: this.ascDescs[id].key,
            label: this.ascDescs[id].label,
            checked: true,
            value: this.ascDescs[id].value
          });
        } else {
          this.ascDescs.splice(id, 1, {
            key: this.ascDescs[id].key,
            label: this.ascDescs[id].label,
            checked: false,
            value: this.ascDescs[id].value
          });
        }
      }
      this.sort.asc_desc = ad;
    },
    hideSort() {
      this.$emit("hide-sort", this.sort);
    }
  }
};
</script>
<style scoped lang="less">
.sort-containner {
  border: 1px solid gray;
  border-radius: 10px;
  width: 500px;
  height: 500px;
  margin-left: 200px;
  margin-top: 300px;
}
.sort-items {
  width: 100%;
  height: 460px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
}
.sort-asc-desc {
  width: 100%;
  height: 60px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid gray;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/Sort.vue